// src/components/Common/ReportStatusBadge.jsx
import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle,
  Pending,
  Edit,
  Cancel,
  Info,
  Flag
} from '@mui/icons-material';

const ReportStatusBadge = ({ status, type = 'self-report', size = 'small', isFlagged = false }) => {
  const effectiveStatus = (isFlagged || status === 'flagged') ? 'flagged' : status;

  const getStatusConfig = () => {
    switch (effectiveStatus) {
      case 'flagged':
        return {
          label: 'Flagged',
          color: 'error',
          icon: <Flag fontSize="small" />
        };
      case 'draft':
        return {
          label: 'Draft',
          color: 'default',
          icon: <Edit fontSize="small" />
        };
      case 'pending_approval':
        return {
          label: 'Pending Approval',
          color: 'warning',
          icon: <Pending fontSize="small" />
        };
      case 'approved':
        return {
          label: 'Approved',
          color: 'success',
          icon: <CheckCircle fontSize="small" />
        };
      case 'rejected':
        return {
          label: 'Rejected',
          color: 'error',
          icon: <Cancel fontSize="small" />
        };
      case 'amended':
        return {
          label: 'Amended',
          color: 'info',
          icon: <Info fontSize="small" />
        };
      case 'not_started':
        return {
          label: 'Not Started',
          color: 'default',
          icon: null
        };
      case 'in_progress':
        return {
          label: 'In Progress',
          color: 'primary',
          icon: <Edit fontSize="small" />
        };
      case 'completed':
        return {
          label: 'Completed',
          color: 'success',
          icon: <CheckCircle fontSize="small" />
        };
      case 'not_requested':
        return {
          label: 'Not Requested',
          color: 'default',
          icon: null
        };
      case 'requested':
        return {
          label: 'Requested',
          color: 'info',
          icon: <Pending fontSize="small" />
        };
      case 'claimed':
        return {
          label: 'Claimed',
          color: 'primary',
          icon: <Edit fontSize="small" />
        };
      default:
        return {
          label: effectiveStatus,
          color: 'default',
          icon: null
        };
    }
  };

  const config = getStatusConfig();
  const isFilled = ['completed', 'approved', 'flagged'].includes(effectiveStatus);

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={config.icon}
      variant={isFilled ? 'filled' : 'outlined'}
      sx={{
        fontWeight: 700,
        fontSize: size === 'small' ? '0.62rem' : '0.7rem',
        height: size === 'small' ? '18px' : '22px',
        ...(effectiveStatus === 'flagged' ? {
          bgcolor: '#EF4444',
          color: '#FFFFFF',
          '& .MuiChip-icon': {
            color: '#FFFFFF'
          }
        } : {}),
        '& .MuiChip-icon': {
          fontSize: size === 'small' ? '0.75rem' : '0.875rem',
          marginLeft: '4px'
        },
        '& .MuiChip-label': {
          paddingLeft: config.icon ? '3px' : '6px',
          paddingRight: '6px'
        },
        borderRadius: '4px',
        borderWidth: isFilled ? 0 : '1px',
        boxShadow: 'none',
        transition: 'all 0.2s ease',
      }}
    />
  );
};

export default ReportStatusBadge;